export function getCurrentDateLinuxMs() {
    return Math.floor(Date.now() );
}
